import { ref, reactive } from '@vue/composition-api'
import committeesApi from '@/services/api/committees'

export default function useCommitteeDrafts() {
  const drafts = ref([])
  const loading = ref(false)

  const params = reactive({
    season: new Date().getFullYear(),
    sort: null,
    direction: null
  })

  async function fetch() {
    loading.value = true
    try {
      const query = { year: params.season }
      if (params.sort) {
        query.sort = params.sort
        query.direction = params.direction
      }
      const res = await committeesApi.drafts(query)
      drafts.value = res.data.data
    } finally {
      loading.value = false
    }
  }

  function setYear(year) {
    params.season = year
    fetch()
  }

  function setSort(field) {
    if (params.sort !== field) {
      params.sort = field
      params.direction = 'asc'
    } else if (params.direction === 'asc') {
      params.direction = 'desc'
    } else {
      params.sort = null
      params.direction = null
    }
    fetch()
  }

  return {
    drafts,
    loading,
    params,
    fetch,
    setYear,
    setSort
  }
}



// WEBPACK FOOTER //
// ./src/composables/committees/useCommitteeDrafts.js